<template>
  <div class="financial" v-if="userEqui == 'pc'">
    <div class="allShrink">
      <div class="header-banner">
        <!-- TODO  暂时做隐藏等有时间做优化-->
        <div class="login-area" v-if="!showLogin" style="display: none;">
          <login-area></login-area>
        </div>
        <div class="swiper">
          <el-carousel
            class="carousel"
            :interval="4000"
            :loop="true"
            arrow="always"
            height="500px"
          >
            <el-carousel-item>
              <!-- <p class="slogan">沉睡资产变增收活水</p> -->
              <img src="../../assets/imgs/banner4.png" alt="" />
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>

      <!-- 快速链接 -->
      <f-quick-link></f-quick-link>

      <!-- 成果展示 -->
      <achieve-display></achieve-display>

      <!-- 放款动态 -->
      <!-- <production-performance></production-performance> -->

      <!-- <landtrust-statistics></landtrust-statistics> -->
    </div>
  </div>
  <div class="financial-web" v-else>
    <div class="allShrink-web">
      <div class="header-banner-web">
        <div class="login-area" v-if="!showLogin">
          <login-area></login-area>
        </div>
        <div class="swiper-web">
          <el-carousel
            class="carousel-web"
            :interval="4000"
            :loop="true"
            arrow="always"
            height="150px"
          >
            <el-carousel-item>
              <div class="swiper-item-web">
                 <img class="item-img-web" src="../../assets/imgs/banner4.png" alt=""/>
              </div>
              <!-- <p class="slogan">沉睡资产变增收活水</p> -->
              <!-- <img src="../../assets/imgs/banner4.png" alt="" /> -->
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>

      <!-- 快速链接 -->
      <f-quick-link></f-quick-link>

      <!-- 成果展示 -->
      <achieve-display></achieve-display>

      <!-- 放款动态 -->
      <!-- <production-performance></production-performance> -->

      <!-- <landtrust-statistics></landtrust-statistics> -->
    </div>
  </div>
</template>

<script>
import { getStore } from "@/js/utils/store";
import LoginArea from "@/components/LoginArea";
import FQuickLink from "./components/FQuickLink.vue";
import AchieveDisplay from "./components/AchieveDisplay.vue";
import ProductionPerformance from "./components/ProductionPerformance.vue";
import LandtrustStatistics from "./components/LandtrustStatistics.vue";

export default {
  metaInfo: {
    title: window.pageConfiguration.company.title,
    meta: [
      {
        name: "description",
        content: window.pageConfiguration.company.description,
      },
      { name: "keywords", content: window.pageConfiguration.company.keywords3 },
    ],
  },
  components: {
    LoginArea,
    FQuickLink,
    AchieveDisplay,
    LandtrustStatistics,
    ProductionPerformance,
  },

  data() {
    return {
      userEqui: sessionStorage.getItem("equiType"), //设备类型 参数为web或pc
      equiWidth: sessionStorage.getItem("equiWidth"), //设备宽度 参数为用户当前设备的实际宽度（单位：px）
      showLogin: getStore({ name: "access_token" }),
    };
  },
};
</script>

<style lang="less" scoped>
.financial {
  background: #fff;
  text-align: left;
  display: grid;

  .allShrink {
    width: 90%;
    margin: auto;
  }
}
.financial-web {
  background: #fff;
  .allShrink-web {
    .header-banner-web {
      .swiper-web {
        width: 100%;
    // height: 500px;
    text-align: center;
    background: #fff;
    // position: relative;
        .carousel-web{
          height: 150px;
          width:100%;
          .swiper-item-web {
          position: relative;
          .slogan-web {
            position:absolute;
            color: #fff;
            font-size: 18px;
            left: 40px;
            top: 30px;
            z-index:999;
          }
          .item-img-web {
            // position:absolute;
            width: 100%;
            height: 150px;
          }
        }
        }
      }
    }
  }
}
</style>
